import { render, staticRenderFns } from "./AdminSurveyDocument.vue?vue&type=template&id=ef8b9ed2&scoped=true&"
import script from "./AdminSurveyDocument.vue?vue&type=script&lang=js&"
export * from "./AdminSurveyDocument.vue?vue&type=script&lang=js&"
import style0 from "./AdminSurveyDocument.vue?vue&type=style&index=0&id=ef8b9ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8b9ed2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
